import {SurveyRequestValue} from './survey-request-value';

export class SurveyRequest {
  id: string;
  values: SurveyRequestValue[];
}
